import {
  BetaRegistrationDto,
  CreateBetaRegistrationDto,
  EtxeApiPrefixes,
  EtxeApiSlugs,
  VerifyBetaRegistrationTokenDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';

export class BetaRegistrationConnector {
  private slug = EtxeApiSlugs.BETA_REGISTRATION;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  register(dto: CreateBetaRegistrationDto): Observable<BetaRegistrationDto> {
    return this.apiCaller.postRequest<BetaRegistrationDto>(EtxeApiPrefixes.PUBLIC, `${this.slug}`, dto);
  }

  verify(dto: VerifyBetaRegistrationTokenDto): Observable<{ success: boolean; message: string }> {
    return this.apiCaller.postRequest<{ success: boolean; message: string }>(
      EtxeApiPrefixes.PUBLIC,
      `${this.slug}/verify`,
      dto,
    );
  }
}
